export const SUPPORT_EMAIL = 'support@pixiepets.app';
